// Every DVA card colour, so a saved booking still shows its card's name.
export const DVA_CARD_TYPE = [
  {
    label: 'Gold',
    value: 'gold',
  },
  {
    label: 'White',
    value: 'white',
  },
  {
    label: 'Lilac',
    value: 'lilac',
  },
  {
    label: 'Orange',
    value: 'orange',
  },
  {
    label: 'Blue',
    value: 'blue',
  },
];

// The colours a patient can choose when booking, as in pbt-ui.
const SELECTABLE_DVA_CARD_TYPES = ['gold', 'white', 'orange'];

export const DVA_CARD_TYPE_OPTIONS = DVA_CARD_TYPE.filter(({ value }) =>
  SELECTABLE_DVA_CARD_TYPES.includes(value)
);
